export default __webpack_public_path__ + "static/media/ULTRAMARINE.c484b127.svg";